import { FC } from "react"

interface ReferralSummary {
  total_referrals: number
  total_referrers: number
  total_points_awarded: number
}

interface ReferralSummaryCardsProps {
  summary: ReferralSummary
}

export const ReferralSummaryCards: FC<ReferralSummaryCardsProps> = ({ summary }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6">
      <div className="p-4 bg-gray-50 dark:bg-[rgba(139,92,246,0.05)] rounded-lg">
        <div className="text-sm text-gray-500 dark:text-gray-400">Total Referrals</div>
        <div className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{summary.total_referrals}</div>
      </div>
      <div className="p-4 bg-gray-50 dark:bg-[rgba(139,92,246,0.05)] rounded-lg">
        <div className="text-sm text-gray-500 dark:text-gray-400">Active Referrers</div>
        <div className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{summary.total_referrers}</div>
      </div>
      <div className="p-4 bg-gray-50 dark:bg-[rgba(139,92,246,0.05)] rounded-lg">
        <div className="text-sm text-gray-500 dark:text-gray-400">Points Awarded</div>
        <div className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{summary.total_points_awarded.toLocaleString()}</div>
      </div>
    </div>
  )
}
